import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';

export class QuoteProductVisibilityPolicyDataService extends DataService<typeof Model.Bookings.Logic.ViewModels.QuoteProductVisibilityPolicyItem, Model.Bookings.Logic.ViewModels.QuoteProductVisibilityPolicyItem, QuoteProductVisibilityPolicyItem> {
	protected map(entity: Model.Bookings.Logic.ViewModels.QuoteProductVisibilityPolicyItem): QuoteProductVisibilityPolicyItem {
		return new QuoteProductVisibilityPolicyItemModel(entity);
	}

	static make(ctx?: any): QuoteProductVisibilityPolicyDataService {
		return new QuoteProductVisibilityPolicyDataService(ctx, ctx => ctx.QuoteProductVisibilityPolicies);
	}

	add(defaultLanguage: string): Promise<QuoteProductVisibilityPolicyItem> {
		const entity = new Model.Bookings.Logic.ViewModels.QuoteProductVisibilityPolicyItem();

		(entity as any).dynamicProperties = {
			displayName: {
				[defaultLanguage]: ''
			},
			visibility: { client: [], agent: [], supplier: [] }
		};

		return this.create(() => entity);
	}
}

export class QuoteProductVisibilityPolicyItemModel extends EntityModel<Model.Bookings.Logic.ViewModels.QuoteProductVisibilityPolicyItem, QuoteProductVisibilityPolicyItem> implements QuoteProductVisibilityPolicyItem {
	@property<QuoteProductVisibilityPolicyItemModel>(o => o.entity.id, (o, value) => o.entity.id = value)
	public id: number;

	@property<QuoteProductVisibilityPolicyItemModel>(o => o.entity.isActive, (o, value) => o.entity.isActive = value)
	public isActive: boolean;

	@property<any>(o => o.entity.dynamicProperties, (o, value) => o.entity.dynamicProperties = value)
	public dynamicProperties: any;

	@property<QuoteProductVisibilityPolicyItemModel>(o => o.entity.rules, (o, value) => o.entity.rules = value)
	public rules: PolicyRuleItem[];
}



// WEBPACK FOOTER //
// ./src/app/bookings/quote-product-visibility-policies/form/quote-product-visibility-policy-form.data.ts